export default "__VITE_ASSET__c18fac57__"